import React, { MutableRefObject, useEffect } from 'react';
import classNames from 'classnames';
import styles from './Actions.module.scss';

export function Title({ className = null, children = null, ...props }) {
  className = classNames(styles.title, 'text-small', className);
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}

export const Input = React.forwardRef<any, any>(
  ({ className, ...props }, ref: MutableRefObject<HTMLInputElement>) => {
    useEffect(() => {
      setTimeout(() => {
        if (props.autoFocus) {
          ref?.current?.focus();
        }
      }, 0);
    }, []);
    return <input className={classNames(className, styles.input)} ref={ref} {...props} />;
  },
);

export function ItemContainer({ children, className, ...props }: React.HTMLProps<any>) {
  className = classNames(className, styles.itemContainer);

  return (
    <div {...props} className={className}>
      {children}
    </div>
  );
}

export function ItemPrimary({ children, className, ...props }: React.HTMLProps<any>) {
  className = classNames(className, styles.itemPrimary);

  return (
    <span {...props} className={className}>
      {children}
    </span>
  );
}

export function ItemAccessory({ children, className, ...props }: React.HTMLProps<any>) {
  className = classNames(styles.itemAccessory, className);

  return (
    <span {...props} className={className}>
      {children}
    </span>
  );
}

type ItemProps = React.HTMLProps<any> & {
  as?: React.ElementType<any>;
  active?: boolean;
  hover?: boolean;
  focus?: boolean;
};

export const Item = React.forwardRef(
  (
    {
      as: Component = 'div',
      children,
      active = false,
      hover = false,
      focus = false,
      className,
      ...props
    }: ItemProps,
    ref,
  ) => {
    className = classNames(className, styles.item, {
      [styles.itemActive]: active === true,
      [styles.itemHover]: hover === true,
      [styles.itemFocus]: focus === true,
      [styles.disabled]: props.disabled === true,
    });

    return (
      <Component className={className} {...props} ref={ref}>
        {children}
      </Component>
    );
  },
);

export const Content = React.forwardRef<HTMLElement, any>(
  ({ className, children, ...props }, ref) => {
    className = classNames(className, styles.content);

    return (
      <div ref={ref} className={className} {...props}>
        {children}
      </div>
    );
  },
);
